import {MovieService,PageService, RegionService} from 'hasta-la-vista-middleware-api/service'
import Vue from 'vue'

export default {
    name: 'film-festivals',
    data(){
        return {
            filmFestivals: [],
            loading: true
        }
    },
    created() {
    	Promise.resolve(PageService.getFilmFestivals()).then(
    		(result) => { 
    			this.filmFestivals = result;
    			this.loading = false
                if (this.$breakpoints.xs || this.$breakpoints.sm) {
                    Vue.nextTick(() => {
                        if (this.$parent.$el != undefined) window.scroll({
                            top: (this.$parent.$el.offsetTop - 100),
                            left: 0,
                            behavior: 'smooth'
                        })
                    })
                }
                // console.log(this.filmFestivals)
            },
    		(error) => { console.log(error)}
    	);
    }
}



// WEBPACK FOOTER //
// ./src/components/exclusive-to-sk/film-festivals/film-festivals.js